import React, { PureComponent } from 'react';
import { mapValues, pickBy } from 'lodash';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_KAFKA } from '../../../../constants/connectionCategories';
import DateUtils from '../../../../lib/DateUtils';

const OFFSET_LABELS = {
  earliest: 'Earliest',
  latest: 'Latest',
  from_date: 'From date',
  manual: 'Manual',
};

class KafkaSourceConfiguration extends PureComponent {
  render() {
    const { config } = this.props;

    return (
      <ConfigurationFields
        {...this.props}
        connectionCategory={CONNECTION_CATEGORY_KAFKA}
        config={pickBy(mapValues(config, this._getReadableValue), this._shouldDisplayField)}
      />
    );
  }

  _getReadableValue(value, key) {
    switch (key) {
      case 'offset.mode':
        return OFFSET_LABELS[value];

      case 'start.from.date':
        return DateUtils.convertDateStringToFormat(value);

      default:
        return value;
    }
  }

  _shouldDisplayField(value, key) {
    return key !== 'key.deserializer' && key !== 'value.deserializer';
  }
}

export default KafkaSourceConfiguration;
